import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import { faTrash } from '@fortawesome/pro-regular-svg-icons';

import AddControl from 'components/add_control';
import DateFormGroup from 'bundles/apex/dates/form_group';
import Button from 'shared/button/button';

const RemindersFields = ({
  asInputGroup,
  dateNameWhitelist,
  deal,
  fields,
  label,
  popperContainer,
  popperPlacement,
  reminders = [],
  showAddControl = true,
  onChange,
}) => {
  const remindersToDestroy = reminders.filter(reminder => reminder._destroy);
  reminders = reminders.filter(reminder => !reminder._destroy);

  const handleAdd = () => {
    onChange([...reminders, { sendOn: null }]);
  };

  const handleDelete = (index) => {
    if (reminders[index].id) {
      remindersToDestroy.push({ ...reminders[index], _destroy: true });
    }
    reminders.splice(index, 1);

    onChange([...reminders, ...remindersToDestroy]);
  };

  const handleValueChange = (value, index) => {
    reminders[index] = {
      ...reminders[index],
      sendOn: {
        ...value,
      },
    };

    onChange(reminders);
  };

  if ((reminders && reminders.length === 0) && !showAddControl) {
    return null;
  }

  return (
    <div className="d-flex flex-column gap-2">
      {reminders && reminders.length > 0
        ? reminders.map((reminder, index) => (
          <div
            className={classNames('d-flex gap-2', {
              'align-items-center': asInputGroup,
              'align-items-end': !asInputGroup,
            })}
            key={index}
            name="reminderField"
          >
            <DateFormGroup
              aria-label="reminder"
              asInputGroup={asInputGroup}
              className="task-modal-reminder-form-group flex-fill"
              dateNameWhitelist={dateNameWhitelist}
              deal={deal}
              fields={fields}
              label={label || 'Reminder Date'}
              popperContainer={popperContainer}
              popperPlacement={popperPlacement}
              value={reminder.sendOn}
              onValueChange={value => handleValueChange(value, index)}
            />
            <Button icon={faTrash} name="remove" variant="ghost" onClick={() => handleDelete(index)} />
          </div>
        ))
        : null}

      {showAddControl &&
        <AddControl onClick={handleAdd}>Add Reminder</AddControl>
      }
    </div>
  );
};

RemindersFields.propTypes = {
  asInputGroup: PropTypes.bool,
  dateNameWhitelist: PropTypes.array,
  deal: PropTypes.object,
  fields: PropTypes.object,
  label: PropTypes.node,
  popperContainer: PropTypes.elementType,
  popperPlacement: PropTypes.string,
  reminders: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    sendOn: PropTypes.object,
  })),
  showAddControl: PropTypes.bool,
  onChange: PropTypes.func,
};

export default RemindersFields;
